export enum ViewState {
    LOADING = "loading",
    FETCHED = "fetched",
    EMPTY = "empty",
    ERROR = "error"
}
